import React, { useState, useEffect } from "react";

const CountdownTimer = () => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    // Set the base date (e.g., first cycle start date)
    const baseDate = new Date("2025-07-24T00:00:00Z").getTime(); // UTC
    const cycleDuration = 5 * 24 * 60 * 60 * 1000; // 5 days in ms

    const updateCountdown = () => {
      const now = new Date().getTime();
      const elapsed = now - baseDate;

      const timeInCycle = cycleDuration - (elapsed % cycleDuration);

      const days = Math.floor(timeInCycle / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeInCycle / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((timeInCycle / (1000 * 60)) % 60);
      const seconds = Math.floor((timeInCycle / 1000) % 60);

      setCountdown({ days, hours, minutes, seconds });
    };

    updateCountdown(); // initial call
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const timeItems = [
    { value: countdown.days, label: "Days" },
    { value: countdown.hours, label: "Hours" },
    { value: countdown.minutes, label: "Minutes" },
    { value: countdown.seconds, label: "Seconds" },
  ];

  return (
    <div className="flex items-center bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400/90 rounded-xl shadow-lg backdrop-blur-md px-3 sm:px-6 py-3 sm:py-4 gap-[6px] sm:gap-4 md:gap-6 max-w-full overflow-x-auto no-scrollbar">
      {timeItems.map((item, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center min-w-[45px] sm:min-w-[55px] shrink-0">
            <span className="text-white font-bold text-base sm:text-2xl md:text-4xl leading-none">
              {String(item.value).padStart(2, "0")}
            </span>
            <span className="text-neutral-100 text-[10px] sm:text-sm md:text-base font-medium mt-1">
              {item.label}
            </span>
          </div>
          {index < timeItems.length - 1 && (
            <div className="flex items-center justify-center px-1 shrink-0">
              <span className="text-white font-bold text-base sm:text-2xl md:text-4xl leading-none">:</span>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CountdownTimer;
